import moment from 'moment';
import Counterpart from '@gandi/counterpart';
import enhanceTranslate from './enhanceTranslate';
const toMomentLocaleMap = {
  'zh-hans': 'zh-cn',
  'zh-hant': 'zh-tw'
};
const getSeparatorCount = (str, sep) => str.split(sep).length - 1;
const checkIntPart = (part, otherSep) => {
  const splittedInt = part.split(otherSep);
  if (splittedInt.length === 1) return true;
  return splittedInt.every((thousand, index) => {
    if (index === 0) {
      return thousand.length <= 3;
    }
    return thousand.length === 3;
  });
};
const separationFn = (amount, sep) => {
  let formattedString = '';
  const otherSep = sep === '.' ? ',' : '.';
  const [intPart, ...decimalParts] = amount.split(sep);
  if (!checkIntPart(intPart, otherSep)) {
    return NaN;
  }
  decimalParts.forEach((split, index) => {
    let tmp = '';
    if (split.length < 3 && index > 0) {
      return NaN;
    }
    if (split.length <= 2 && decimalParts.indexOf(split) === decimalParts.length - 1 && amount.split(sep).length === 2 && amount.split(otherSep).every((str, idx) => idx > 0 ? str.length >= 3 : true)) {
      tmp = amount.split(otherSep).join('').split(sep).join('.');
    } else if (split.length >= 3 && split.split(otherSep)[0].length === 3 && (split.split(otherSep)[1] ? split.split(otherSep)[1].length === 2 : true)) {
      tmp = amount.split(sep).join('').split(otherSep).join('.');
    }
    formattedString = formattedString !== '' ? tmp === formattedString ? tmp : NaN : tmp;
    return formattedString;
  });
  return Number.parseFloat(`${formattedString}`);
};
const formatUserAmount = userAmount_ => {
  const userAmount = userAmount_.replace(/\s/g, '');
  const separators = [',', '.'];
  const regex = /[^[0-9\s,.]/gm;
  if (userAmount.match(regex)) {
    return NaN;
  }
  if (separators.every(sep => userAmount.indexOf(sep) === -1)) {
    return Number.parseInt(userAmount, 10);
  }
  if (getSeparatorCount(userAmount, ',') > 1 && getSeparatorCount(userAmount, '.') > 1) {
    return NaN;
  }
  return getSeparatorCount(userAmount, '.') === 1 ? separationFn(userAmount, '.') : separationFn(userAmount, ',');
};
const i18nDefaultParams = {
  translations: {},
  localeData: {},
  locale: 'en',
  defaultLocale: 'en',
  logMissing: false
};
function createTranslator(i18n, logger = console) {
  const {
    translations = i18nDefaultParams.translations,
    locale = i18nDefaultParams.locale,
    defaultLocale = i18nDefaultParams.defaultLocale,
    logMissing = i18nDefaultParams.logMissing,
    localeData = i18nDefaultParams.localeData
  } = i18n;
  const translator = new Counterpart.Instance();
  const availableLanguages = [locale, defaultLocale];
  availableLanguages.forEach(locale_ => {
    translator.registerTranslations(locale_, translations);
  });
  translator.setLocale(locale);
  translator.setFallbackLocale(defaultLocale);
  translator.setSeparator('|');
  if (logger && global.__DEV__ && logMissing) {
    const handleTranslationNotFound = evt => {
      logger.warn(`Translation not found: ${evt.detail.locale} => "${evt.detail.key}"`);
    };
    translator.onTranslationNotFound(handleTranslationNotFound);
  }
  const translate = enhanceTranslate(i18n.scope, translator.translate.bind(translator), i18n.sanitize, logger);
  const localize = (date, toUtc = true) => toUtc ? moment.utc(date).locale(toMomentLocaleMap[locale] || locale) : moment(date).locale(toMomentLocaleMap[locale] || locale);
  const createNumberFormat = options => new Intl.NumberFormat(locale, {
    ...options
  });
  const mapCurrencyISOToSymbol = currencyISO => {
    return localeData.number?.currencies?.[currencyISO] ?? currencyISO;
  };
  return {
    translate,
    localize,
    createNumberFormat,
    mapCurrencyISOToSymbol,
    formatUserAmount
  };
}
export default createTranslator;